export default __webpack_public_path__ + "images/phone-in-hand-outline-white.da7084c3be8e7eda58a5e21aceb68f18.png";